import { LoyaltyInventoryBalance } from '@models/loyalty/types';
import { getCurrentSite } from '@src/app/utils/domainHelpers';
import { getConfig } from '@superbet-group/web.lib.config';
import {
    createRestClient,
    RestClient,
} from '@superbet-group/web.lib.rest';

import { defaultHttpTimeoutMs } from '@core/constants';
import { getOptions } from './utils';

export class InventoryService {
    constructor(private readonly client: RestClient) {}

    getBalance(sessionId: string): Promise<LoyaltyInventoryBalance> {
        return this.client.get<LoyaltyInventoryBalance>('/currency', getOptions(sessionId));
    }
}

const config = getConfig();
const country = config.countrySpecific.country;
const brand = getCurrentSite(window.location.hostname).toLowerCase();
export const inventoryService: InventoryService = new InventoryService(
    createRestClient(
        `${config.loyaltyIntegration?.baseUrl}/default/inventory/${country}/${brand}`,
        defaultHttpTimeoutMs,
    ),
);
